/**
 * The two screens' image slots, in the Editor's reading order (desktop first).
 *
 * SINGLE-TARGET EACH, and load-bearing twice over:
 *
 *  - it is what makes the size floor per screen. `BlockMediaSlot` offers the
 *    library against `slot.targets[0]`, so a photo need only be large enough for
 *    the screen it is going into — a wide shot that could never fill the tall
 *    mobile crop is still fine for the desktop one. A multi-target slot would
 *    apply `frame-multi-target-slot`'s all-or-nothing floor and forbid exactly
 *    the pairing this block exists for.
 *  - it keeps each screen's picture its OWN stored reference. Deriving the
 *    second framing from the first would collapse the case where both screens
 *    name the same photo.
 *
 * THE TWO SIZES MUST DIFFER. A crop is identified by the size it was cropped to
 * (`cropId = "{w}x{h}"`, media.service.ts:377), so giving both screens a common
 * size makes two pictures of one photo indistinguishable from one picture served
 * everywhere — which is the whole claim of this block.
 */
export const MEDIA_SCREEN_IMAGE_SLOTS = [
    {
        key: 'desktopImage',
        label: 'Desktop picture',
        targets: [{ width: 1920, height: 1080, aspectRatio: '16:9' }],
    },
    {
        key: 'mobileImage',
        label: 'Mobile picture',
        targets: [{ width: 1080, height: 1920, aspectRatio: '9:16' }],
    },
];
/**
 * The slot schema for a block art-directed per screen.
 *
 * No `layout`, deliberately: a media block displays its pictures in every
 * rendering, so `filled-slot-never-silently-dropped`'s filled-but-hidden trap
 * cannot arise here and there is nothing to warn an Editor about.
 */
export function perScreenMediaSchema(componentId) {
    return {
        componentId,
        scalarSlots: [{ key: 'caption', label: 'Caption', type: 'textarea' }],
        mediaSlots: MEDIA_SCREEN_IMAGE_SLOTS,
    };
}
export const mediaSchema = perScreenMediaSchema('Media');
//# sourceMappingURL=media.js.map